import "../../../../content/projects/okko/okko.css";
import * as React from 'react';
export default {
  React
};